import React from 'react';
import './css/buy.css';

function Buy({ title }) {
    const subject = encodeURIComponent(`Inquiry about ${title}`);

    return (
        <div className="purchase-contact">
            <p>
                For more information about <strong>{title}</strong>, please{' '}
                email <a href={`mailto:bryanswhitehead@gmail.com?subject=${subject}`}>bryanswhitehead@gmail.com</a>{' '}
                or text me at <a href="sms:5132993032">513-299-3032</a>.
            </p>
        </div>
    );
}

export default Buy;
